import React from 'react'
import { fnum } from '../../utils/utils'
import PRSEditPmntForm from './PRSEditPmntForm'
import moment from 'moment'

export default class PRSPmntItem extends React.Component {

  state = {
    edit: false,
    errors: {}
  };

  onclick = e => {
    e.preventDefault();
    this.setState({edit:true});
  }

  cancelEdit = () => {
    this.setState({edit:false});
  }

  makePayment = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.editPost({
      post_id: this.props.data.post_id,
      post_payed: 1
    }, (err) => {
      if(err){
        this.setState({
          errors: err
        });
      }
      else {
        this.setState({
          errors: {}
        });
      }
    });
  }

  render() {

    const {
      data,
      updtBlnc,
      editPost,
      addSets,
      srvcs,
      pmntLinkOptions,
      orderPayment
    } = this.props;
    const { edit, errors } = this.state;
    const pColor = data.post_payed ? 'green' :
      (data.post_bdate <= moment().format('Y-MM-DD') ? 'red' : 'black');
    if (edit){
      return (
        <PRSEditPmntForm
          data={data}
          pmntLinkOptions={pmntLinkOptions}
          cancelEdit={this.cancelEdit}
          updtBlnc={updtBlnc}
          editPost={editPost}
          orderPayment={orderPayment}
          addSets={addSets}
          srvcs={srvcs}
        />
      );
    }
    else{
      return (
        <tr className="text-success" onClick={this.onclick}>
          <td></td>
          <td style={{paddingLeft: "50px"}}>
            {data.post_desc}
            {errors.form && (
              <div className="text-danger">{errors.form}</div>
            )}
          </td>
          <td className="text-right">{fnum(data.post_price)}</td>
          <td className="text-right">{fnum(data.post_qntt)}</td>
          <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
          <td></td>
          <td></td>
          <td className="hover-popup-container">
            <span style={{color:pColor}}>
              {(data.post_payed ? 'Оплачено ' : 'Оплатить ') + moment(data.post_bdate).format('L')}
            </span>
            {data.post_note && <span> {data.post_note}</span>}
            <div className="hover-popup">
              {!data.post_payed && (
                <button
                  className="btn btn-success"
                  onClick={this.makePayment}
                >
                  Оплатить
                </button>
              )}
            </div>
          </td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSPmntItem.js